module.exports = __webpack_public_path__ + "static/media/filter.553f251a.svg";